import React from 'react';
import siteUtils from '../../utils/site';

const messages = {
  gdpr: {
    title: 'Important Notice',
    message: `In accordance with the EU GDPR rights to privacy, you affirm that you, a data controller,
    have obtained the necessary consent required for AdMobilize, a data processor,
    to transmit this image for you to view from anyone whose personally identifiable information
    may be contained in the image if said image is from a camera within the EU.`,
    link: 'https://www.admobilize.com/#!/policies/gdpr',
    acceptButton: 'Accept'
  },
  archiveDevice: {
    title: 'Device Archive Warning!',
    actionDetails: deviceName => (
      <>
        <b>This action will affect this device: </b>
        {deviceName}
      </>
    ),
    message: (
      <>
        Are you sure that you want to archive this device? Contact{' '}
        <a href="mailto:support@admobilize.com">support@admobilize.com</a> to reactivate this device and restore the
        data.
        <br />
        <br />
        Archived device data will be <b>deleted after 30 days</b>.
      </>
    ),
    acceptButton: 'Proceed'
  },
  dearchiveDevice: {
    title: 'Device Dearchive',
    actionDetails: deviceName => (
      <>
        <b>This action will affect this device: </b>
        {deviceName}
      </>
    ),
    message: <>Are you sure that you want to dearchive this device? </>,
    acceptButton: 'Proceed'
  },
  enableHeatmap: {
    title: 'Device Archive Warning!',
    actionDetails: deviceName => (
      <>
        <b>This action will affect this device: </b>
        {deviceName}
      </>
    ),
    message: <>Are you sure that you want to enable heatmap for this device?</>,
    acceptButton: 'Proceed'
  },
  disableHeatmap: {
    title: 'Device Archive Warning!',
    actionDetails: deviceName => (
      <>
        <b>This action will affect this device: </b>
        {deviceName}
      </>
    ),
    message: <>Are you sure that you want to disable heatmap for this device?</>,
    acceptButton: 'Proceed'
  },
  deleteReport: {
    title: 'Please, take caution!',
    actionDetails: reportName => `This action will affect this report: ${reportName}`,
    message: `Are you sure that you want to delete this report?`,
    acceptButton: 'Proceed'
  },
  deleteProject: {
    title: 'Please, take caution!',
    actionDetails: project => {
      let msg = `This action will affect the site group (${project.displayName}`;
      msg += project.devicesCount ? `) and ${project.devicesCount} devices will be deleted.` : ').';
      msg += ` This action is not reversible.`;
      return msg;
    },
    message: 'Are you sure that you want to delete this site group?',
    acceptButton: 'Proceed'
  },
  deleteSite: {
    title: 'Please, take caution!',
    actionDetails: site => {
      let msg = `This action will affect the site (${site.displayName}`;
      msg += site.attachedDevices.lenght > 0 ? `) and ${site.attachedDevices.lenght} devices will be deleted.` : ')';
      return msg;
    },
    message: 'Are you sure that you want to delete this site?',
    acceptButton: 'Proceed'
  },
  deletePortal: {
    title: 'Please, take caution!',
    actionDetails: portal => {
      let msg = `This action will affect the portal (${portal.displayName})`;
      return msg;
    },
    message: 'Are you sure that you want to delete this portal?',
    acceptButton: 'Proceed'
  },
  deleteCampaign: {
    title: 'Please, take caution!',
    actionDetails: campaign => `This action will affect the campaign: ${campaign.displayName}`,
    message: 'Are you sure that you want to delete this campaign?',
    acceptButton: 'Proceed'
  },
  deleteWebEmbed: {
    title: 'Please, take caution!',
    actionDetails: webEmbedName => `This action will affect the Web Embed: ${webEmbedName}`,
    message: 'Are you sure that you want to delete this Web Embed?',
    acceptButton: 'Proceed'
  },

  removePinVersion: {
    title: 'Remove Pin Version',
    message: `Are you sure that you want remove the version pinned?`,
    acceptButton: 'Proceed'
  },
  noModifications: {
    title: 'No Changes will be applied',
    message: `Are you sure that you want to proceed? No changes will be applied.`,
    acceptButton: 'Proceed'
  },
  moveAssetDevice: {
    title: 'Move Device to this Asset?',
    actionDetails: choice => {
      const siteName = choice?.attachedSite?.displayName || choice?.attachedSite?.id || 'another Site';
      const assetNames = (choice?.attachedSite?.assets || []).map(asset => asset.displayName || asset.id).join(', ');
      return (
        <span>
          <b>Site:</b> {siteName} · <b>Asset:</b> {assetNames || 'Unknown Asset'} · <b>Device:</b>{' '}
          {choice?.displayName || choice?.id}
        </span>
      );
    },
    message: 'The Device will be detached from Assets in the other Site before it is attached here.',
    acceptButton: 'Move Device'
  },
  upgradeSiteDatasources: {
    title: 'Update Site solution?',
    actionDetails: context => {
      const { site, datasources = [] } = context || {};
      return (
        <>
          <b>Site:</b> {site?.displayName || site?.id} · <b>New solution:</b>{' '}
          {siteUtils.getSolutionLabel(datasources)}
        </>
      );
    },
    message:
      'The Device uses a solution that this Site does not support. Would you like to update the Site solution so it can be attached?',
    cencelButton: 'Cancel',
    acceptButton: 'Update solution'
  }
};

export default messages;
